import chroma from 'chroma-js';
import {iclamp} from './misc.js'

export class ScenePlayer {
    constructor (mscene) {
        this.playing = false;
        this.paused =  false;
        this.stopped = true;
        this.scene = mscene;
        // The radial timer control is always created and used, but setting this to
        // false will prevent the circular stroke from being visible.
        this.useRadialTimer = false;
        this.currentT = 0;

        this.getLinesFromScene(mscene);
        this.createUI("Test Player");
    }

    getLinesFromScene(mscene) {
        var player = this;

        // Each line will produce up to 2 timeouts
        // First, a timeout for the line's offset (250ms default). If this is 0,
        // then no timeout.
        // Next, a timeout for the line's duration.
        // We want to be able to call each timeout sequentially, so we'll store them
        // in an array for easy index-based access
        this.lines = [];

        var linesHTML = mscene.exportHTML(false, false, true, false, mscene.show_next);

        for(var i = 0; i < mscene.lines.length; i++) {
            this.lines.push({
                line:  mscene.lines[i],
                html:  linesHTML[i],
                timeoutFunc: null,
                offsetTimeout: null,
                lineTimeout: null
            });
        }

        // Parse each line's html and figure out its indices
        this.lines.forEach(function (line) {
            // Parse the line
            var inTag = false;
            // Array of chars
            var filteredChars = [];
            // Array of indices into line string that map to filtered chars
            line.filteredLocationMap = [];

            var nextSpot = line.html.indexOf("<p class=\"next\">");

            if (nextSpot == -1) {
                nextSpot = line.html.length;
            }

            for (var i = 0; i < nextSpot; i++)
            {
                var c = line.html[i];

                // Flag start of tag
                if (c == '<' && !inTag)
                {
                    inTag = true;
                }
                // Flag end of tag
                else if (c == '>' && inTag)
                {
                    inTag = false;
                }
                // Flag whitespace
                else if (c == ' ' || c == '\n' || c == '\r')
                {
                    continue;
                }
                // Add text to filtered collection if there's no tag
                else if (!inTag)
                {
                    filteredChars.push(c);
                    line.filteredLocationMap.push(i);
                }
            }

            line.filteredText = filteredChars.join("");
            line.filteredStartIndex = 0;
            line.filteredStopIndex = line.filteredText.length - 1;

            var castId = line.line.castId;

            if (castId != null && castId != 0) {
                castId -= 1;
                // Actor's name is followed by a colon
                var castName = player.scene.cast[castId].name.replace(" ", "") + ":";
                line.filteredStartIndex = line.filteredText.indexOf(castName);

                if (line.filteredStartIndex != -1) {
                    line.filteredStartIndex += castName.length;
                }
            }

            // Update the index indicating the end of the string being colored
            if (nextSpot != line.html.length) {
                var idx = -1;

                for(var i = 0; i < line.filteredLocationMap.length; i++) {
                    var loc = line.filteredLocationMap[i];

                    if (loc >= nextSpot) {
                        idx = iclamp(i - 1, 0, line.filteredText.length - 1);
                        break;
                    }
                }
                if (idx != -1) {
                    line.filteredStopIndex = idx;
                }
            }
        });

        // Index for timeout access
        this.lineIndex = 0;

        // Set up timeouts
        this.lines.forEach(function(entry) {
            // Offset in milliseconds
            //var offset = mscene.interval * 1000;
            var offset = entry.line.delay * 1000;
            // Line duration in milliseconds
            var lineDur = entry.line.duration * 1000;

            // Needs to trigger 2 timeouts. First one is for the offset, second one
            // is for the line time
            entry.timeoutFunc = function() {
                // setTimeout(fn, dur) calls fn after dur. So for a line update,
                // we need to wait the offset (250ms), then call the code that sets
                // the line, then call a timeout for the next one to be done.

                // Set up a callback that will set the line div content after the
                // offset duration for this line passes
                entry.offsetTimeout = player.callTimeout(function() {
                    player.setCurrentLine(entry, lineDur, offset);
                }, offset);
            };
        });
    }

    setCurrentLine(entry, duration, delay = 0) {
        var player = this;
        this.currentLine = entry;
        this.lineDuration = duration;
        if (entry) {
            // Set up timeout so when this line finishes, the player increments
            entry.lineTimeout = this.callTimeout(function() {
                player.callNextEntry();
            }, duration, true);

            this.setLine(this.currentLine.html);
        }
        else {
            this.setLine();
        }
    }

    setLine(line = null) {
        this.lineDiv.innerHTML = line ? line : "";
    }

    updateLine (t = 0.0) {
        if (this.currentLine && this.currentLine.filteredText != "") {

            var colorStopIndex = this.currentLine.filteredStartIndex
                + Math.round((this.currentLine.filteredStopIndex - this.currentLine.filteredStartIndex) * t);

            colorStopIndex = iclamp(colorStopIndex, this.currentLine.filteredStartIndex, this.currentLine.filteredStopIndex);

            var trueStartIndex = this.currentLine.filteredLocationMap[this.currentLine.filteredStartIndex];
            var trueStopIndex = this.currentLine.filteredLocationMap[colorStopIndex];

            var karaokeColor = "FFFFFF";

            var colorizedCurrentLine = String.format("{0}<strong style=\"color: #{1};\">{2}</strong>{3}",
                this.currentLine.html.substring(0, trueStartIndex),
                karaokeColor,
                this.currentLine.html.substring(trueStartIndex, trueStopIndex),
                this.currentLine.html.substring(trueStopIndex)
            );

            this.setLine(colorizedCurrentLine);
        }
    }

    createUI(dialogTitle = "") {
        var player = this;

        // Player container
        this.div = $("<div/>").attr("id", "player_div").appendTo("body");

        this.div.dialog({
            autoOpen: false,
            show: {
                effect: "puff",
                duration: 100
            },
            hide: {
                effect: "explode",
                duration: 100
            },
            width: "80vw",
            height: 600,
            title: dialogTitle,
            close: function() {
                player.stop();

                $(this).dialog('destroy').remove();
            }
        });

        // Resizes the dialog
        $(window).resize(function () {
            $("#player_div").dialog("option", "position", {my: "center", at: "center", of: window});
        });

        // Controls div contains timer and buttons
        var controlsDiv = document.createElement("div");
        controlsDiv.id = "player_controls_div";
        this.div.append(controlsDiv);

        this.elapsedDiv = document.createElement("div");
        this.elapsedDiv.id = "elapsed_div";
        controlsDiv.appendChild(this.elapsedDiv);

        this.timerDiv = document.createElement("div");
        this.timerDiv.id = "player_timer_div";
        controlsDiv.appendChild(this.timerDiv);

        //td.appendChild(this.timerDiv);
        //td.id = "timer_td";

        //td.appendChild(document.createElement("br"));

        // Add player buttons
        var buttonDiv = document.createElement("div");
        buttonDiv.id = "player_button_div";
        controlsDiv.appendChild(buttonDiv);
        var playPauseButton = document.createElement("button");
        buttonDiv.appendChild(playPauseButton);
        playPauseButton.innerHTML = "play";
        playPauseButton.onclick = function() {
            if (player.playing) {
                player.pause();
                playPauseButton.innerHTML = "resume";
            }
            else {
                player.play();
                playPauseButton.innerHTML = "pause";
            }
        };

        var stopButton = document.createElement("button");
        buttonDiv.appendChild(stopButton);
        stopButton.innerHTML = "stop";
        stopButton.onclick = function() {
            player.stop();
            playPauseButton.innerHTML = "play";
        };


        // Row 1, col 2: Displays line
        // td = document.createElement("td");
        // td.align = "center";
        // td.valign = "top";
        // tr.appendChild(td);
        this.lineDiv = document.createElement("div");
        this.lineDiv.id = "player_line_div";
        this.div.append(this.lineDiv);


        // // Row 2: player buttons
        // tr = document.createElement("tr");
        // tbody.appendChild(tr);
        // td = document.createElement("td");
        // tr.appendChild(td);
    }

    // Sets flags for playing and calls the next line entry
    play () {
        if (this.playing) {
            return;
        }

        let lastTime = performance.now();

        // Handle play differently if previously paused
        if (this.paused) {
            this.resume();
            lastTime = performance.now();
        }
        else {
            this.timeSinceStart = 0;
            this.playing = true;
            this.paused = false;
            this.stopped = false;
            this.startedAt = performance.now();

            this.callNextEntry();
        }

        let that = this;

        this.elapsedInterval = setInterval(function() {
            if (that.playing) {
                let now = performance.now();
                let delta = now - lastTime;

                that.timeSinceStart += delta;
                lastTime = now;

                that.elapsedDiv.innerHTML = (that.timeSinceStart / 1000).toFixed(2);
            }
            
        }, 50);
        
    }

    // Sets flags for pause, record time of pause, clear the next line timeout, and
    // stop the radial timer
    pause = function () {
        if (this.playing) {
            this.playing = false;
            this.paused = true;
            this.stopped = false;

            this.pauseTime = Date.now();

            if (this.currentTimeout) {
                clearTimeout(this.currentTimeout);
            }

            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }

            if (this.elapsedInterval) {
                clearInterval(this.elapsedInterval);
            }

            if (this.radialTimer) {
                this.radialTimer.stop();
            }
        }
    }

    // Resume play from pause
    resume () {
        if (this.paused) {
            this.playing = true;
            this.paused = false;
            this.stopped = false;

            // Get time remaining based on
            var timeLeft = this.currentDuration - (this.pauseTime - this.currentStartTime);

            // Check if we should set the timer
            var setTimer = this.currentSetTimer;

            // This will call the paused timeout with the appropriate amount of time
            // remaining. It'll also update the timeout flags so we can support
            // multiple pauses per line
            this.callTimeout(this.currentFunction, timeLeft, false, true);

            this.currentSetTimer = setTimer;

            // If the paused timeout had set the timer, then we should update it
            // to reflect the resume command
            if (setTimer) {
                // Update the timer to use the amount of time left
                this.setLineTimer(timeLeft, false);
                this.radialTimer.set(this.currentT);
                this.animateTimer(1.0);
            }
        }
    }

    // Stops the player all together
    stop () {
        this.playing = false;
        this.paused = false;
        this.stopped = true;
        // Resets the current entry counter back to 0
        this.lineIndex = 0;

        // Clear current line
        this.setCurrentLine();

        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        }

        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }

        // Stop the timer
        if (this.radialTimer) {
            this.radialTimer.stop();
            this.radialTimer.destroy();
            this.radialTimer = null;
        }

        
        if (this.elapsedInterval) {
            clearInterval(this.elapsedInterval);
            this.elapsedInterval = null;
        }
    }

    // Calls the current line entry's timeout functions to update the timer and
    // line div, then increments the current line entry counter. When the counter
    // exceeds the number of lines, calls stop.
    callNextEntry () {
        if (this.playing) {
            if (this.lineIndex < this.lines.length) {
                this.lines[this.lineIndex].timeoutFunc();
                this.lineIndex++;
            }
            else {
                this.stop();
            }
        }
    }

    // Function for setting the radial timer duration.
    // Couldn't tell from the progressbar.js documentation, but there might be
    // a better way to reset the timer without destroying the old and creating
    // a brand new one. Meanwhile, oh well!
    setLineTimer (durationMS, realDuration = 0,
        startAnimation = true, animationVal = 1.0) {
        var player = this;

        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }

        if (this.radialTimer) {
            this.radialTimer.destroy();
        }

        this.radialTimer = new ProgressBar.Circle("#player_timer_div", {
            color: '#f2f2f2',
            strokeWidth: 6,
            trailWidth: 1,
            text: {
                value: (durationMS / 1000.0).toFixed(1).toString()
            },
            duration: durationMS
        });

        if (realDuration === 0) {
            this.radialTimer.duration = durationMS;
        }
        else {
            this.radialTimer.duration = realDuration;
        }

        if (startAnimation) {
            this.animateTimer(animationVal);
        }

    }

    animateTimer (t, startTime = 0) {
        var player = this;

        // Actually begins the timer to transition from 1 (full) to 0 (empty)
        if (startTime === 0) {
            startTime = Date.now();
        }

        if (this.radialTimer) {
            this.radialTimer.startTime = startTime;

            this.radialTimer.stop();
            this.radialTimer.animate(t, {
                step: function(state, circle, attachment) {
                    var t = player.radialTimer.value();
                    var color = chroma.mix("#00FF0000", "#FF0000", t, "hsl");
                    circle.path.setAttribute('stroke', player.useRadialTimer ? color : null);
                }
            }, function () {
                player.radialTimer.setText("0.00");
            });
        }


        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }

        this.timerInterval = setInterval(function() {
            if (player.playing) {
                // Update timer display
                player.currentT = player.radialTimer.value();
                player.updateLine(player.currentT);
                var durationDiff = player.lineDuration * (1.0 - player.currentT);
                if (durationDiff >= 0) {
                    player.radialTimer.setText((durationDiff / 1000.0).toFixed(1).toString());
                }
            }
        }, 50);
    }

    // Wrapper function to help this player set timeouts. This way, we can
    // always have a reference to any timeout currently active for play/pause
    // purposes.
    callTimeout (fn, durationMS, setTimer = false, updateFlags = true) {
        var to = setTimeout(fn, durationMS);
        if (updateFlags) {
            this.currentTimeout = to;
            this.currentFunction = fn;
            this.currentDuration = durationMS;
            this.currentStartTime = Date.now();
            this.currentSetTimer = setTimer;
        }

        if (setTimer) {
            this.setLineTimer(durationMS);
        }
    }

}